import * as types from './locationActionTypes';

export default (
  state = {
    location: [],
    error: null,
    loading: false,
  },
  action
) => {
  switch (action.type) {
    case types.GET_LOCATION_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.GET_LOCATION_SUCCESS:
      return {
        ...state,
        loading: false,
        location: action.location,
      };
    case types.GET_LOCATION_ERROR:
      return {
        ...state,
        location: [],
        loading: false,
        error: action.error,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/store/location/locationReducer.js